export default function isBase64(property) {
  return property.charAt(0) === 'd' && property.charAt(1) === 'a' && property.charAt(2) === 't' && property.charAt(3) === 'a' && property.charAt(4) === ':';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-dom/node_modules/fela-utils/es/isBase64.js
// module id = 154
// module chunks = 0